// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

interface i_use_scroll_to_top_props {
    behavior?: ScrollToOptions['behavior'];
}
export const use_scroll_to_top = (props?: i_use_scroll_to_top_props)=>{
    const {behavior = 'smooth'} = props || {};
    const {pathname} = useLocation();
    useEffect(()=>{
        window.scrollTo({top: 0, behavior});
    }, [pathname]);
};
